export const LUGARES = [
  { value: "veterinaria", label: "Veterinaria" },
  { value: "tienda_mascotas", label: "Tienda de mascotas" },
  { value: "supermercado", label: "Supermercado" },
  { value: "online", label: "En línea / a domicilio" },
  { value: "otro", label: "Otro" },
];

export const FRECUENCIAS = ["Cada semana", "Cada 2 semanas", "Cada mes", "Cada 2 meses", "Cada 3 meses o más"];

export const MOTIVOS = [
  "Recomendación del veterinario",
  "Precio",
  "Calidad / ingredientes",
  "A mi mascota le gusta",
  "Salud / dieta especial",
  "Disponibilidad / fácil de conseguir",
  "Costumbre",
  "Otro",
];

export const INTERES = [
  { value: "si", label: "¡Sí, me encantaría!" },
  { value: "tal_vez", label: "Tal vez, cuéntenme más" },
  { value: "no", label: "Por ahora no" },
];

export const ESTADOS = [
  { value: "nuevo", label: "Nuevo", cls: "bg-teal/40 text-charcoal" },
  { value: "contactado", label: "Contactado", cls: "bg-peach text-coral-dark" },
  { value: "muestra_enviada", label: "Muestra enviada", cls: "bg-sage text-charcoal" },
  { value: "cliente", label: "Cliente", cls: "bg-coral text-white" },
  { value: "no_interesado", label: "No interesado", cls: "bg-charcoal/10 text-muted-moss" },
];

export const lugarLabel = (v) => LUGARES.find((l) => l.value === v)?.label || v;
export const interesLabel = (v) => INTERES.find((l) => l.value === v)?.label || v;
export const estadoInfo = (v) => ESTADOS.find((e) => e.value === v) || ESTADOS[0];

const uid = () => Math.random().toString(36).slice(2, 10);
export const emptyFood = () => ({ _k: uid(), marca: "", linea: "", kg: "", precio: "", lugar_compra: "", lugar_nombre: "", frecuencia: "", motivo: "" });
export const emptyPet = () => ({ _k: uid(), nombre_mascota: "", tipo: "", cantidad: 1, alimentos: [emptyFood()] });
export const emptySurvey = () => ({ nombre: "", telefono: "", zona: "", mascotas: [emptyPet()], interes_prueba: "", observaciones: "" });

const FOOD_REQ = ["marca", "kg", "precio", "lugar_compra", "lugar_nombre", "frecuencia", "motivo"];

export function validateSurvey(f) {
  const e = {};
  if (!f.nombre.trim()) e.nombre = true;
  if (f.telefono.replace(/\D/g, "").length !== 8) e.telefono = true;
  if (!f.zona.trim()) e.zona = true;
  if (!f.interes_prueba) e.interes_prueba = true;
  f.mascotas.forEach((m, i) => {
    if (!m.nombre_mascota.trim()) e[`m${i}.nombre_mascota`] = true;
    if (!m.tipo) e[`m${i}.tipo`] = true;
    if (!(Number(m.cantidad) >= 1)) e[`m${i}.cantidad`] = true;
    m.alimentos.forEach((a, j) => FOOD_REQ.forEach((k) => {
      const bad = k === "kg" || k === "precio" ? !(Number(a[k]) > 0) : !String(a[k]).trim();
      if (bad) e[`m${i}.a${j}.${k}`] = true;
    }));
  });
  return e;
}

export function toPayload(f) {
  const strip = ({ _k, ...rest }) => rest;
  return {
    ...f,
    telefono: f.telefono.replace(/\D/g, ""),
    mascotas: f.mascotas.map((m) => ({
      ...strip(m),
      cantidad: Number(m.cantidad),
      alimentos: m.alimentos.map((a) => ({ ...strip(a), kg: Number(a.kg), precio: Number(a.precio) })),
    })),
  };
}
